import styled from 'styled-components'

const QuestionsContainer = styled.div`
    width: 83.33333333%;
    margin: 0 auto;
    padding: 25px 0px;
    max-width: 975px;
`

const QuestionsTitle = styled.h2`
    font-family: Barlow, sans-serif;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 35px;
    text-align: center;
`

const QuestionTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    background: #fee5ec;
    padding: 12px 15px;
    cursor: pointer;
    user-select: none;
    transition: all 0.4s ease;
`

const QuestionContent = styled.div`
    padding: 20px 15px;
    font-size: 14px;
`

const QuestionIcon = styled.span`
    padding-right: 10px;
    font-size: 12px;
    &:before {
        content: '▼';
    }
`

const QuestionItem = styled.div`
    border-bottom: 1px solid #ccc;
    overflow: hidden;
    max-height: 45px;
    transition: all 0.4s ease;
    cursor: pointer;
    &:last-child {
        border-bottom: none;
    }

    &:hover {
        max-height: initial;
        ${QuestionTitle} {
            background: #f0b8c7;
        }
    }
    
    &:hover ${QuestionIcon} {
        &:before {
            content: '▲';
        }
    }
`

export {
    QuestionsContainer,
    QuestionItem,
    QuestionTitle,
    QuestionContent,
    QuestionsTitle,
    QuestionIcon
}